import { render, staticRenderFns } from "./ChurchForget.vue?vue&type=template&id=2f7e6ef2&scoped=true"
import script from "./ChurchForget.vue?vue&type=script&lang=js"
export * from "./ChurchForget.vue?vue&type=script&lang=js"
import style0 from "./ChurchForget.vue?vue&type=style&index=0&id=2f7e6ef2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f7e6ef2",
  null
  
)

export default component.exports